import { signOut } from "../api/rest/authApi";
import useLocalStorageVO from "../components/Common/UseLocalStorageVO";
import Swal from "sweetalert2";

function UseLogout() {
    const { isLogin, logout } = useLocalStorageVO();

    const logoutProcess = async () => {
        if (isLogin()) {
            const res = await signOut()
            console.log(res)
            if (res.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: '성공',
                    text: '로그아웃 성공',
                    timer: 600,
                    showConfirmButton: false
                });
            }
        }

        logout()
    }

    return { logoutProcess }
}

export default UseLogout